// extracted by mini-css-extract-plugin
export default {"sidebar":"Layout_sidebar__MAGSf","content":"Layout_content__BJTy7","header":"Layout_header__PQb99","footer":"Layout_footer__ysaJu","grid_wrapper":"Layout_grid_wrapper__eejjl"};